import React, { useState, useEffect } from 'react';
import createNotification from '../../utils/createNotification';
import { useStateSelector } from '../../store/selectors';
import { APP_URL } from '../../../src/utils/config.js';

const NdaStep = (props) => {
    const [, setNdaData] = useState(null);
    const [isRequestInProcess, setIsRequestInProcess] = useState(false);
    const [, setIsNdaSigned] = useState(false);
    const [embedUrl, setEmbedUrl] = useState('');
    const [isNdaCheckCompleted, setIsNdaCheckCompleted] = useState(false);
    const [pollNdaCount, setPollNdaCount] = useState(0);
    const [maxPollCount] = useState(50);
    const [, setIsNdaPollSuccess] = useState(false);
    const axios = useStateSelector((state) => state.core.axios);
    const height = (window.innerHeight - 200).toString() + 'px';

    useEffect(() => {
        axios
            .get('/api/digitalSign')
            .then((response) => {
                let needToGenerateSignRequest = false;
                if (
                    response &&
                    response.data &&
                    response.data.data &&
                    response.data.data.digiSign
                ) {
                    const digiSign = response.data.data.digiSign;
                    setNdaData(digiSign);
                    setIsRequestInProcess(
                        response.data.data.isRequestInProcess
                    );
                    setIsNdaSigned(digiSign.isSignerSigned);
                    setEmbedUrl(digiSign.signRequestUrl);
                    setIsNdaCheckCompleted(true);
                    if (digiSign.isSignerSigned) {
                        needToGenerateSignRequest = false;
                        props.updateNdaStatus(true);
                    } else if (digiSign && !digiSign.isSignerSigned) {
                        setEmbedUrl(digiSign.signRequestUrl);
                        needToGenerateSignRequest = false;
                        initiateNdaPoll();
                    } else {
                        needToGenerateSignRequest = true;
                    }
                } else {
                    needToGenerateSignRequest = true;
                }
                if (needToGenerateSignRequest) {
                    axios
                        .post('/api/DigitalSign')
                        .then((response) => {
                            if (
                                response &&
                                response.data &&
                                response.data.data
                            ) {
                                setEmbedUrl(response.data.data.embedUrl);
                                setIsNdaCheckCompleted(true);
                                initiateNdaPoll();
                            }
                        })
                        .catch((err) =>
                            console.log('generating nda req: ', err)
                        );
                }
            })
            .catch((err) => console.log('onload: ', err));
    }, []);

    const initiateNdaPoll = () => {
        // can start polling for nda status here
        setPollNdaCount(pollNdaCount + 1);
        if (pollNdaCount <= maxPollCount) {
            axios
                .get('/api/digitalSign')
                .then((response) => {
                    if (
                        response &&
                        response.data &&
                        response.data.data &&
                        response.data.data.digiSign
                    ) {
                        setIsRequestInProcess(
                            response.data.data.isRequestInProcess
                        );
                        if (response.data.data.digiSign.isSignerSigned) {
                            setIsNdaPollSuccess(true);
                            props.updateNdaStatus(true);
                            // we have verified that sigining was successful. Can proceed to login and send to dashboard/ other required page
                            createNotification(
                                'NDA signing has been verified successfully!',
                                'success'
                            );
                        } else {
                            // need to poll to fetch status
                            setTimeout(() => {
                                initiateNdaPoll();
                            }, 2000);
                        }
                    }
                })
                .catch((err) => console.log('initiateNdaPoll: ', err));
        } else {
            createNotification(
                'Could not verify whether NDA Signing was successful. We will send you an email with an update. Meanwhile feel free to contact our customer support if needed.',
                'error'
            );
        }
    };

    const renderIframe = () =>
        isNdaCheckCompleted && embedUrl ? (
            <iframe title="NDA Signing" src={embedUrl}></iframe>
        ) : (
            'Refresh to load..'
        );

    return (
        <div
            className="nda-form"
            style={{
                height: height,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            {isRequestInProcess ? (
                <iframe
                    src={`${
                        APP_URL == '/' ? window.location.origin : APP_URL
                    }/nda-success/`}></iframe>
            ) : (
                renderIframe()
            )}
        </div>
    );
};
export default NdaStep;
